<div role="main" class="main">

  <section class="page-header">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <ul class="breadcrumb">
            <li><a href="/">Anasayfa</a></li>
            <li class="active">Referans Projeler</li>
          </ul>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <h1>Referans Projeler</h1>
        </div>
      </div>
    </div>
  </section>

  <div class="container">

    <ul class="nav nav-pills sort-source" data-sort-id="portfolio" data-option-key="filter" data-plugin-options="{'layoutMode': 'fitRows', 'filter': '*'}">
      <li data-option-value="*" class="active"><a href="javascript:void(0)">Hepsi</a></li>
      <li data-option-value=".ios"><a href="javascript:void(0)">Ios</a></li>
      <li data-option-value=".android"><a href="javascript:void(0)">Android</a></li>
      <li data-option-value=".web"><a href="javascript:void(0)">Web</a></li>
      <li data-option-value=".iot"><a href="javascript:void(0)">Iot</a></li>
    </ul>

    <hr>

    <div class="row">
      <div class="sort-destination-loader sort-destination-loader-showing">
        <ul class="portfolio-list sort-destination" data-sort-id="portfolio">

          <!-- Project item-->
          <li class="col-md-12 isotope-item mt-xl ios">
            <div class="row">
              <div class="col-md-6">
                <div class="portfolio-item">
                    <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                      <span class="thumb-info-wrapper">
                        <img src="assets/img/projects/gizli.png" class="img-responsive" alt="">

                      </span>
                    </span>
                </div>
              </div>
              <div class="col-md-6">
                <h4 class="heading-primary">İmece</h4>
                <p class="mt-xlg">Halkbank'ın saha elemanlarının kullandığı ürün tanıtımları ve satışlarını yaptıkları iPad uygulaması</p>

                <div class="header-logo">
                                 <!--<a href="apple link https://itunes.apple.com/tr/app/orbies/id1245865156?mt=8">
                                 <img alt="YKBTech" width="152" height="45" src="assets/img/projects/appstore.png">
                                 </a>

                                 <a href=" https://play.google.com/store/apps/details?id=com.orb.orbiesapp">
                                 <img alt="YKBTech" width="152" height="45" src="assets/img/projects/googleplay.png">
                                 </a>-->
                            </div>

                <ul class="portfolio-details">
                  <li>
                    <p><strong>Kullanılan Teknolojiler</strong></p>

                    <ul class="list list-inline list-icons">
                      <li><i class="fa fa-check-circle"></i> Swift</li>
                      <li><i class="fa fa-check-circle"></i> Rest Api</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <!-- -->

          <!-- Project item-->
          <li class="col-md-12 isotope-item mt-xl ios android">
            <div class="row">
              <div class="col-md-6">
                <div class="portfolio-item">
                    <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                      <span class="thumb-info-wrapper">
                        <img src="assets/img/projects/ustala_usta.png" class="img-responsive" alt="">

                      </span>
                    </span>
                </div>
              </div>
              <div class="col-md-6">
                <h4 class="heading-primary">Ustala - Hizmet Veren</h4>
                <p class="mt-xlg">Usta hizmet verenleri bir araya getiren ve ustaların teklifler verebilmesini sağlar</p>

                <div class="header-logo">

                                 <a href="https://apps.apple.com/us/app/id1502957675">
                                 <img alt="YKBTech" width="152" height="45" src="assets/img/projects/appstore.png">
                                 </a>

                                 <a href=" https://play.google.com/store/apps/details?id=com.ustala.usta">
                                 <img alt="YKBTech" width="152" height="45" src="assets/img/projects/googleplay.png">
                                 </a>
                            </div>

                <ul class="portfolio-details">
                  <li>
                    <p><strong>Kullanılan Teknolojiler</strong></p>

                    <ul class="list list-inline list-icons">
                      <li><i class="fa fa-check-circle"></i> Swift</li>
                      <li><i class="fa fa-check-circle"></i> Java</li>
                      <li><i class="fa fa-check-circle"></i> Android</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <!-- -->

          <!-- Project item-->
          <li class="col-md-12 isotope-item mt-xl ios android">
            <div class="row">
              <div class="col-md-6">
                <div class="portfolio-item">
                    <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                      <span class="thumb-info-wrapper">
                        <img src="assets/img/projects/ustala_musteri.png" class="img-responsive" alt="">

                      </span>
                    </span>
                </div>
              </div>
              <div class="col-md-6">
                <h4 class="heading-primary">Ustala</h4>
                <p class="mt-xlg">Usta hizmet verenleri bir araya getiren ve işleriniz için uygun ustayı bulmanızı sağlar</p>

                <div class="header-logo">

                                 <a href="https://apps.apple.com/us/app/id1505575915">
                                 <img alt="YKBTech" width="152" height="45" src="assets/img/projects/appstore.png">
                                 </a>

                                 <a href=" https://play.google.com/store/apps/details?id=com.ustala.musteri">
                                 <img alt="YKBTech" width="152" height="45" src="assets/img/projects/googleplay.png">
                                 </a>
                            </div>

                <ul class="portfolio-details">
                  <li>
                    <p><strong>Kullanılan Teknolojiler</strong></p>

                    <ul class="list list-inline list-icons">
                      <li><i class="fa fa-check-circle"></i> Swift</li>
                      <li><i class="fa fa-check-circle"></i> Java</li>
                      <li><i class="fa fa-check-circle"></i> Android</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <!-- -->
          <!-- Project item-->
          <li class="col-md-12 isotope-item mt-xl ios">
            <div class="row">
              <div class="col-md-6">
                <div class="portfolio-item">
                    <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                      <span class="thumb-info-wrapper">
                        <img src="assets/img/projects/yemekgelir.png" class="img-responsive" alt="">

                      </span>
                    </span>
                </div>
              </div>
              <div class="col-md-6">


                <h4 class="heading-primary">Yemekgelir</h4>
                <p class="mt-xlg">Firmaların üye olup müşterilerin adresine göre yemek siparişleri verebildiği mobil uygulamadır.</p>

                <div class="header-logo">
                                 <a href="https://apps.apple.com/tr/app/yemekgelir/id1480343136?l=tr">
                                 <img alt="YKBTech" width="152" height="45" src="assets/img/projects/appstore.png">
                                 </a>

                            </div>

                <ul class="portfolio-details">
                  <li>
                    <p><strong>Kullanılan Teknolojiler</strong></p>

                    <ul class="list list-inline list-icons">
                      <li><i class="fa fa-check-circle"></i> Swift</li>
                      <li><i class="fa fa-check-circle"></i> Rest Api</li>
                      <li><i class="fa fa-check-circle"></i> Web Socket</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <!-- -->
          <!-- Project item-->
          <li class="col-md-12 isotope-item mt-xl android">
            <div class="row">
              <div class="col-md-6">
                <div class="portfolio-item">
                    <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                      <span class="thumb-info-wrapper">
                        <img src="assets/img/projects/vita.png" class="img-responsive" alt="">

                      </span>
                    </span>
                </div>
              </div>
              <div class="col-md-6">
                <h4 class="heading-primary">Vita</h4>
                <p class="mt-xlg">Personel servis araçlarının günlük rotaları, görevleri, personel listesi vs yönetimlerini yapabildikleri, Harita üzerinde anlık olarak takibatının yapıldığı, alarm durumlarının yönetildiği, şöför hakedişlerinin hesaplandığı araç ve sefer takip uygulaması </p>

                <div class="header-logo">

                            </div>

                <ul class="portfolio-details">
                  <li>
                    <p><strong>Kullanılan Teknolojiler</strong></p>

                    <ul class="list list-inline list-icons">
                      <li><i class="fa fa-check-circle"></i> Java</li>
                      <li><i class="fa fa-check-circle"></i> Rest Api</li>
                      <li><i class="fa fa-check-circle"></i> Firebase RealtimeDB</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <!-- -->
          <!-- Project item-->
          <li class="col-md-12 isotope-item mt-xl ios android">
            <div class="row">
              <div class="col-md-6">
                <div class="portfolio-item">
                    <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                      <span class="thumb-info-wrapper">
                        <img src="assets/img/projects/orbies.png" class="img-responsive" alt="">

                      </span>
                    </span>
                </div>
              </div>
              <div class="col-md-6">
                <h4 class="heading-primary">Orbies</h4>
                <p class="mt-xlg">Orbies, kişisel ve işyeri kullanımı sunan ve harita üzerinde orb oluşturmanızı sağlayan bir uygulamadır. Orb, harita üzerinde fotoğraf, metin paylaşımıdır</p>

                <div class="header-logo">
                                 <!--<a href="apple link https://itunes.apple.com/tr/app/orbies/id1245865156?mt=8">
                                 <img alt="YKBTech" width="152" height="45" src="assets/img/projects/appstore.png">
                                 </a>-->

                                 <a href="https://play.google.com/store/apps/details?id=com.orb.orbiesapp">
                                 <img alt="YKBTech" width="152" height="45" src="assets/img/projects/googleplay.png">
                                 </a>
                            </div>

                <ul class="portfolio-details">
                  <li>
                    <p><strong>Kullanılan Teknolojiler</strong></p>
                    <ul class="list list-inline list-icons">
                      <li><i class="fa fa-check-circle"></i> Swift</li>
                      <li><i class="fa fa-check-circle"></i> Java</li>
                      <li><i class="fa fa-check-circle"></i> Rest Api</li>
                      <li><i class="fa fa-check-circle"></i> Javascript</li>
                      <li><i class="fa fa-check-circle"></i> Php</li>
                      <li><i class="fa fa-check-circle"></i> MySql</li>
                      <li><i class="fa fa-check-circle"></i> Firebase Push Notification</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <!-- -->
          <!-- Project item-->
          <li class="col-md-12 isotope-item mt-xl web ios android">
            <div class="row">
              <div class="col-md-6">
                <div class="portfolio-item">
                    <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                      <span class="thumb-info-wrapper">
                        <img src="assets/img/projects/ode3d.png" class="img-responsive" alt="">

                      </span>
                    </span>
                </div>
              </div>
              <div class="col-md-6">


                <h4 class="heading-primary">3D Öde</h4>
                <p class="mt-xlg">Üye işyelerinin tahsilatlarını fiziksel pos cihazı olmaksızın, android ve ios cihazlardan yapabilmesine olanak sağlayan, ödeme sistemi olarak innova altyapısı ile entegre çalışan sanal pos uygulaması</p>

                <div class="header-logo">

                            </div>

                <ul class="portfolio-details">
                  <li>
                    <p><strong>Kullanılan Teknolojiler</strong></p>

                    <ul class="list list-inline list-icons">
                      <li><i class="fa fa-check-circle"></i> Swift</li>
                      <li><i class="fa fa-check-circle"></i> Java</li>
                      <li><i class="fa fa-check-circle"></i> Rest Api</li>
                      <li><i class="fa fa-check-circle"></i> Php</li>
                      <li><i class="fa fa-check-circle"></i> Mysql</li>
                      <li><i class="fa fa-check-circle"></i> Html/Css</li>
                      <li><i class="fa fa-check-circle"></i> Javascript</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <!-- -->
          <!-- Project item-->
          <li class="col-md-12 isotope-item mt-xl web ios">
            <div class="row">
              <div class="col-md-6">
                <div class="portfolio-item">
                    <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                      <span class="thumb-info-wrapper">
                        <img src="assets/img/projects/tree.png" class="img-responsive" alt="">

                      </span>
                    </span>
                </div>
              </div>
              <div class="col-md-6">

                <h4 class="heading-primary">Tree</h4>
                <p class="mt-xlg">Ailelerin, çocuklarının cihaz kullanımlarını görebilecekleri, gittikleri konumlarda ve internette aradıkları, kendilerinin belirleyeceği kelime ve konumlarda anında haberdar oldukları, web sitelerine engel koyabildikleri, aile ve çocuğun ayrıca kullanacakları uygulama</p>

                <div class="header-logo">

                            </div>

                <ul class="portfolio-details">
                  <li>
                    <p><strong>Kullanılan Teknolojiler</strong></p>

                    <ul class="list list-inline list-icons">
                      <li><i class="fa fa-check-circle"></i> Swift</li>
                      <li><i class="fa fa-check-circle"></i> Rest Api</li>
                      <li><i class="fa fa-check-circle"></i> .Net Core</li>
                      <li><i class="fa fa-check-circle"></i> Azure</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <!-- -->
          <!-- Project item-->
          <li class="col-md-12 isotope-item mt-xl ios">
            <div class="row">
              <div class="col-md-6">
                <div class="portfolio-item">
                    <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                      <span class="thumb-info-wrapper">
                        <img src="assets/img/projects/notif_sdk.png" class="img-responsive" alt="">

                      </span>
                    </span>
                </div>
              </div>
              <div class="col-md-6">


                <h4 class="heading-primary">Custom Push Notification SDK</h4>
                <p class="mt-xlg">Push notification aracılığı ile müşterilerine detaylı içerikleri göndermek ve gereği halinde satın almalarını da buradan yönetebilecekleri mobil notification SDK sının. Sdk metin, resim, gif, video ve html sayfa olarak bildirimler gönderebilmekte ve etkileşime girip raporlar yapabilmektedir</p>

                <div class="header-logo">

                            </div>

                <ul class="portfolio-details">
                  <li>
                    <p><strong>Kullanılan Teknolojiler</strong></p>

                    <ul class="list list-inline list-icons">
                      <li><i class="fa fa-check-circle"></i> Swift</li>
                      <li><i class="fa fa-check-circle"></i> Rest Api</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <!-- -->
          <!-- Project item-->
          <li class="col-md-12 isotope-item mt-xl ios">
            <div class="row">
              <div class="col-md-6">
                <div class="portfolio-item">
                    <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                      <span class="thumb-info-wrapper">
                        <img src="assets/img/projects/notif_test.png" class="img-responsive" alt="">

                      </span>
                    </span>
                </div>
              </div>
              <div class="col-md-6">


                <h4 class="heading-primary">Custom Notification Test Uygulaması</h4>
                <p class="mt-xlg">Geliştirmiş olduğumuz notification sdk uygulamasının özelliklerinin müşterilerimize tanıtımı için geliştirdiğimiz test uygulamasıdır.</p>

                <div class="header-logo">

                            </div>

                <ul class="portfolio-details">
                  <li>
                    <p><strong>Kullanılan Teknolojiler</strong></p>

                    <ul class="list list-inline list-icons">
                      <li><i class="fa fa-check-circle"></i> Swift</li>
                      <li><i class="fa fa-check-circle"></i> Rest Api</li>
                      <li><i class="fa fa-check-circle"></i> Beacon</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <!-- -->
          <!-- Project item-->
          <li class="col-md-12 isotope-item mt-xl ios">
            <div class="row">
              <div class="col-md-6">
                <div class="portfolio-item">
                    <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                      <span class="thumb-info-wrapper">
                        <img src="assets/img/projects/erturk_lines.png" class="img-responsive" alt="">

                      </span>
                    </span>
                </div>
              </div>
              <div class="col-md-6">


                <h4 class="heading-primary">Erturk Lines</h4>
                <p class="mt-xlg">Ertürk Lines firmasının uluslararası deniz seferlerinin araç ve personel taşımacılığına yönelik bilet satış uygulaması</p>

                <div class="header-logo">
                                 <a href="https://apps.apple.com/tr/app/erturk-lines/id1307566245">
                                 <img alt="YKBTech" width="152" height="45" src="assets/img/projects/appstore.png">
                                 </a>

                            </div>

                <ul class="portfolio-details">
                  <li>
                    <p><strong>Kullanılan Teknolojiler</strong></p>

                    <ul class="list list-inline list-icons">
                      <li><i class="fa fa-check-circle"></i> Swift</li>
                      <li><i class="fa fa-check-circle"></i> Rest Api</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <!-- -->
          <!-- Project item-->
          <li class="col-md-12 isotope-item mt-xl web android">
            <div class="row">
              <div class="col-md-6">
                <div class="portfolio-item">
                    <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                      <span class="thumb-info-wrapper">
                        <img src="assets/img/projects/gratude_b2b.png" class="img-responsive" alt="">

                      </span>
                    </span>
                </div>
              </div>
              <div class="col-md-6">


                <h4 class="heading-primary">Gratude B2B</h4>
                <p class="mt-xlg">Tekstil sektöründe faaliyet göstererek üretim yapan Gratude firmasının, ürünlerinin tasarım aşamasından, müşteri siparişleri ve teslimine kadar olan süreçlerin yönetimi. Satış temsilcilerin ürün tanıtım ve sipariş alma uygulaması</p>

                <div class="header-logo">
                                 <!--<a href="apple link https://itunes.apple.com/tr/app/orbies/id1245865156?mt=8">
                                 <img alt="YKBTech" width="152" height="45" src="assets/img/projects/appstore.png">
                                 </a>

                                 <a href=" https://play.google.com/store/apps/details?id=com.orb.orbiesapp">
                                 <img alt="YKBTech" width="152" height="45" src="assets/img/projects/googleplay.png">
                                 </a>-->
                            </div>

                <ul class="portfolio-details">
                  <li>
                    <p><strong>Kullanılan Teknolojiler</strong></p>

                    <ul class="list list-inline list-icons">
                      <li><i class="fa fa-check-circle"></i> Java</li>
                      <li><i class="fa fa-check-circle"></i> Mysql</li>
                      <li><i class="fa fa-check-circle"></i> Html/Css</li>
                      <li><i class="fa fa-check-circle"></i> Javascript</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <!-- -->
          <!-- Project item-->
          <li class="col-md-12 isotope-item mt-xl web">
            <div class="row">
              <div class="col-md-6">
                <div class="portfolio-item">
                    <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                      <span class="thumb-info-wrapper">
                        <img src="assets/img/projects/integra_oto.png" class="img-responsive" alt="">

                      </span>
                    </span>
                </div>
              </div>
              <div class="col-md-6">


                <h4 class="heading-primary">Integra-Oto</h4>
                <p class="mt-xlg">Otomotiv sektöründe stok takibi, tedarikçi entegrasyonları yapılabilen, fiyat, ilan açıklamaları, araç uyumlulukları gibi değerlerin sistem tarafından karar verilerek ilanın hazırlanıp n11, gittigidiyor, hepsiburada, trendyol gibi pazaryerlerine ilan yayınlanmasının yapıldığı uygulama </p>

                <div class="header-logo">

                            </div>

                <ul class="portfolio-details">
                  <li>
                    <p><strong>Kullanılan Teknolojiler</strong></p>

                    <ul class="list list-inline list-icons">
                      <li><i class="fa fa-check-circle"></i> Asp.Net Mvc</li>
                      <li><i class="fa fa-check-circle"></i> Sql Server</li>
                      <li><i class="fa fa-check-circle"></i> Rest Api</li>
                      <li><i class="fa fa-check-circle"></i> Xml Web servisleri</li>
                      <li><i class="fa fa-check-circle"></i> Html/Css</li>
                      <li><i class="fa fa-check-circle"></i> Javascript</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <!-- -->
          <!-- Project item-->
          <li class="col-md-12 isotope-item mt-xl ios web">
            <div class="row">
              <div class="col-md-6">
                <div class="portfolio-item">
                    <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                      <span class="thumb-info-wrapper">
                        <img src="assets/img/projects/nazali_takip.png" class="img-responsive" alt="">

                      </span>
                    </span>
                </div>
              </div>
              <div class="col-md-6">


                <h4 class="heading-primary">Nazalı Takip</h4>
                <p class="mt-xlg">Andersan Tax/Nazalı avukatlık bürosunun müşteri görüşmelerini takip amacı ile kullandığı müşteri takip uygulamasıdır</p>

                <div class="header-logo">

                            </div>

                <ul class="portfolio-details">
                  <li>
                    <p><strong>Kullanılan Teknolojiler</strong></p>

                    <ul class="list list-inline list-icons">
                      <li><i class="fa fa-check-circle"></i> Swift</li>
                      <li><i class="fa fa-check-circle"></i> Rest Api</li>
                      <li><i class="fa fa-check-circle"></i> Asp.Net Mvc</li>
                      <li><i class="fa fa-check-circle"></i> Sql Server</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <!-- -->
          <!-- Project item-->
          <li class="col-md-12 isotope-item mt-xl android">
            <div class="row">
              <div class="col-md-6">
                <div class="portfolio-item">
                    <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                      <span class="thumb-info-wrapper">
                        <img src="assets/img/projects/ihome.png" class="img-responsive" alt="">

                      </span>
                    </span>
                </div>
              </div>
              <div class="col-md-6">


                <h4 class="heading-primary">iHome</h4>
                <p class="mt-xlg">Intestech olarak üretmiş olduğumuz akıllı prizin kontrol uygulamasıdır.</p>

                <div class="header-logo">

                            </div>

                <ul class="portfolio-details">
                  <li>
                    <p><strong>Kullanılan Teknolojiler</strong></p>

                    <ul class="list list-inline list-icons">
                      <li><i class="fa fa-check-circle"></i> Java</li>
                      <li><i class="fa fa-check-circle"></i> Firebase RealtimeDB</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <!-- -->
          <!-- Project item-->
          <li class="col-md-12 isotope-item mt-xl android ios web">
            <div class="row">
              <div class="col-md-6">
                <div class="portfolio-item">
                    <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                      <span class="thumb-info-wrapper">
                        <img src="assets/img/projects/ceksor.png" class="img-responsive" alt="">

                      </span>
                    </span>
                </div>
              </div>
              <div class="col-md-6">


                <h4 class="heading-primary">Çek ve Sor</h4>
                <p class="mt-xlg">ÇekveSor faktoring deneyimlerini bir araya getirip KOBİ ve OBİ'lerin yaşadığı sıkıntılara çözüm sunarken, aynı anda faktoring şirketlerinin ihtiyaçlarına karşılık sağlamayı amaçlayan bir uygulamadır.</p>

                <div class="header-logo">
                                 <!--<a href="https://itunes.apple.com/tr/app/döviz-altın/id499969177?l=tr&mt=8">
                                 <img alt="YKBTech" width="152" height="45" src="assets/img/projects/appstore.png">
                                 </a> -->

                                 <a href="https://play.google.com/store/apps/details?id=ac.app.ceksor">
                                 <img alt="YKBTech" width="152" height="45" src="assets/img/projects/googleplay.png">
                                 </a>
                            </div>

                <ul class="portfolio-details">
                  <li>
                    <p><strong>Kullanılan Teknolojiler</strong></p>

                    <ul class="list list-inline list-icons">
                      <li><i class="fa fa-check-circle"></i> Swift</li>
                      <li><i class="fa fa-check-circle"></i> Java</li>
                      <li><i class="fa fa-check-circle"></i> Html/Css</li>
                      <li><i class="fa fa-check-circle"></i> Javascript</li>
                      <li><i class="fa fa-check-circle"></i> Firebase RealtimeDb</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <!-- -->
          <!-- Project item-->
          <li class="col-md-12 isotope-item mt-xl android">
            <div class="row">
              <div class="col-md-6">
                <div class="portfolio-item">
                    <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                      <span class="thumb-info-wrapper">
                        <img src="assets/img/projects/colored_eyes.png" class="img-responsive" alt="">

                      </span>
                    </span>
                </div>
              </div>
              <div class="col-md-6">


                <h4 class="heading-primary">Colored Eyes</h4>
                <p class="mt-xlg">Colored Eyes, orijinal lensleri kişi fotoğrafı üzerine yerleştirip, ışık ayarlamaları ile birlikte gerçekçi görünüm testi yapmanıza imkan sağlar</p>

                <div class="header-logo">
                                 <!--<a href="youtube link https://itunes.apple.com/tr/app/orbies/id1245865156?mt=8">
                                 <img alt="YKBTech" width="152" height="45" src="assets/img/projects/appstore.png">
                                 </a>-->

                            </div>

                <ul class="portfolio-details">
                  <li>
                    <p><strong>Kullanılan Teknolojiler</strong></p>

                    <ul class="list list-inline list-icons">
                      <li><i class="fa fa-check-circle"></i> Java</li>
                      <li><i class="fa fa-check-circle"></i> Firebase RealtimeDB</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <!-- -->
          <!-- Project item-->
          <li class="col-md-12 isotope-item mt-xl android">
            <div class="row">
              <div class="col-md-6">
                <div class="portfolio-item">
                    <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                      <span class="thumb-info-wrapper">
                        <img src="assets/img/projects/optic_focus.png" class="img-responsive" alt="">

                      </span>
                    </span>
                </div>
              </div>
              <div class="col-md-6">


                <h4 class="heading-primary">Optic Focus</h4>
                <p class="mt-xlg">Optic focus, gözlük firmaların kişiye uygun gözlüğün, yan ve bakış açılarınıza göre ayarlaması işlemini yapar. Buna göre gözlüğünüz yüzünüzde rahat bir duruş sağlar ve cam kesimleriniz de sizin bakış odaklarınıza göre yapılır</p>

                <div class="header-logo">

                            </div>

                <ul class="portfolio-details">
                  <li>
                    <p><strong>Kullanılan Teknolojiler</strong></p>

                    <ul class="list list-inline list-icons">
                      <li><i class="fa fa-check-circle"></i> Java</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <!-- -->
          <!-- Project item-->
          <li class="col-md-12 isotope-item mt-xl android">
            <div class="row">
              <div class="col-md-6">
                <div class="portfolio-item">
                    <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                      <span class="thumb-info-wrapper">
                        <img src="assets/img/projects/kitchen_pro.png" class="img-responsive" alt="">

                      </span>
                    </span>
                </div>
              </div>
              <div class="col-md-6">

                <h4 class="heading-primary">Kitchen Proo</h4>
                <p class="mt-xlg">Tablet/telefon üzerinden mutfak elemanları tasarımının yapılıp, ölçeklendirme ve renklendirmeler ile parçalarının ve ölçülerinin belirlenip kesim makinesine çıktı verebilen uygulamadır.</p>

                <div class="header-logo">

                            </div>

                <ul class="portfolio-details">
                  <li>
                    <p><strong>Kullanılan Teknolojiler</strong></p>

                    <ul class="list list-inline list-icons">
                      <li><i class="fa fa-check-circle"></i> Java</li>
                      <li><i class="fa fa-check-circle"></i> Firebase RealtimeDB</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <!-- -->
          <!-- Project item-->
          <li class="col-md-12 isotope-item mt-xl web android">
            <div class="row">
              <div class="col-md-6">
                <div class="portfolio-item">
                    <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                      <span class="thumb-info-wrapper">
                        <img src="assets/img/projects/setur_mice.png" class="img-responsive" alt="">

                      </span>
                    </span>
                </div>
              </div>
              <div class="col-md-6">


                <h4 class="heading-primary">Setur mice</h4>
                <p class="mt-xlg">Setur firmasının fuarlarda kullandığı, katılımcıların biriş kartları, otel rezervasyonları, bildirimleri ve yönetimlerinin yapıldığı uygulamadır.</p>

                <div class="header-logo">
                                 <a href="https://apps.apple.com/gd/app/seturmice-mobile/id1269045562">
                                 <img alt="YKBTech" width="152" height="45" src="assets/img/projects/appstore.png">
                                 </a>

                                 <a href="https://play.google.com/store/apps/details?id=com.mobistech.seturmice">
                                 <img alt="YKBTech" width="152" height="45" src="assets/img/projects/googleplay.png">
                                 </a>
                            </div>

                <ul class="portfolio-details">
                  <li>
                    <strong>Kullanılan Teknolojiler</strong>

                    <ul class="list list-inline list-icons">
                      <li><i class="fa fa-check-circle"></i> Java</li>
                      <li><i class="fa fa-check-circle"></i> Rest Api</li>
                      <li><i class="fa fa-check-circle"></i> Spring</li>
                      <li><i class="fa fa-check-circle"></i> MySql</li>
                      <li><i class="fa fa-check-circle"></i> Html/Css</li>
                      <li><i class="fa fa-check-circle"></i> Javascript</li>
                      <li><i class="fa fa-check-circle"></i> Firebase Push Notification</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <!-- -->
          <!-- Project item-->
          <li class="col-md-12 isotope-item mt-xl ios">
            <div class="row">
              <div class="col-md-6">
                <div class="portfolio-item">
                    <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                      <span class="thumb-info-wrapper">
                        <img src="assets/img/projects/menokg.png" class="img-responsive" alt="">

                      </span>
                    </span>
                </div>
              </div>
              <div class="col-md-6">


                <h4 class="heading-primary">MenoKg</h4>
                <p class="mt-xlg">Diyet sektörüne hizmet için kurulan MenoKg, bunun yanında detoks ve kilo verme sürecini deneyimleyenlerin buluşma noktası haline gelmiştir</p>

                <div class="header-logo">
                                 <a href="https://apps.apple.com/tr/app/menokg/id1037875561?l=tr">
                                 <img alt="YKBTech" width="152" height="45" src="assets/img/projects/appstore.png">
                                 </a>
                            </div>

                <ul class="portfolio-details">
                  <li>
                    <p><strong>Kullanılan Teknolojiler</strong></p>

                    <ul class="list list-inline list-icons">
                      <li><i class="fa fa-check-circle"></i> Swift</li>
                      <li><i class="fa fa-check-circle"></i> Rest Api</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <!-- -->
          <!-- Project item-->
          <li class="col-md-12 isotope-item mt-xl ios">
            <div class="row">
              <div class="col-md-6">
                <div class="portfolio-item">
                    <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                      <span class="thumb-info-wrapper">
                        <img src="assets/img/projects/true_touch.png" class="img-responsive" alt="">

                      </span>
                    </span>
                </div>
              </div>
              <div class="col-md-6">


                <h4 class="heading-primary">TrueTouch Mobile</h4>
                <p class="mt-xlg">Morse Watchmans firmasının ürünü olan anahtar dolabı yönetim uygulamasıdır</p>

                <div class="header-logo">
                                 <a href="https://apps.apple.com/us/app/truetouch-mobile/id706287235">
                                 <img alt="YKBTech" width="152" height="45" src="assets/img/projects/appstore.png">
                                 </a>
                            </div>

                <ul class="portfolio-details">
                  <li>
                    <p><strong>Kullanılan Teknolojiler</strong></p>

                    <ul class="list list-inline list-icons">
                      <li><i class="fa fa-check-circle"></i> Swift</li>
                      <li><i class="fa fa-check-circle"></i> Rest Api</li>
                      <li><i class="fa fa-check-circle"></i> Xml Web Servisleri</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <!-- -->
          <!-- Project item-->
          <li class="col-md-12 isotope-item mt-xl ios android">
            <div class="row">
              <div class="col-md-6">
                <div class="portfolio-item">
                    <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                      <span class="thumb-info-wrapper">
                        <img src="assets/img/projects/caronex.png" class="img-responsive" alt="">

                      </span>
                    </span>
                </div>
              </div>
              <div class="col-md-6">


                <h4 class="heading-primary">Caronex</h4>
                <p class="mt-xlg">Kaza sonrası sigorta expertiz ve sigorta ödeme, tekliflendirme süreçlerinin yürütüldüğü mobil uygulamadır.</p>

                <div class="header-logo">

                            </div>

                <ul class="portfolio-details">
                  <li>
                    <p><strong>Kullanılan Teknolojiler</strong></p>

                    <ul class="list list-inline list-icons">
                      <li><i class="fa fa-check-circle"></i> React Native</li>
                      <li><i class="fa fa-check-circle"></i> Rest Api</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <!-- -->
          <!-- Project item-->
          <li class="col-md-12 isotope-item mt-xl web">
            <div class="row">
              <div class="col-md-6">
                <div class="portfolio-item">
                    <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                      <span class="thumb-info-wrapper">
                        <img src="assets/img/projects/gizli.png" class="img-responsive" alt="">

                      </span>
                    </span>
                </div>
              </div>
              <div class="col-md-6">


                <h4 class="heading-primary">Kiosk Yönetim</h4>
                <p class="mt-xlg">Kiosk cihazlarındaki mobil uygulamayı yönetecek olan panel uygulamasıdır. Bu uygulama aracılığı ile cihazların anlık durumları raporlanmakta, veri yüklemeleri ve cihaz güncellemesi yapılabilmektedir.</p>

                <div class="header-logo">

                            </div>

                <ul class="portfolio-details">
                  <li>
                    <p><strong>Kullanılan Teknolojiler</strong></p>

                    <ul class="list list-inline list-icons">
                      <li><i class="fa fa-check-circle"></i> Asp.Net Mvc</li>
                      <li><i class="fa fa-check-circle"></i> Sql Server</li>
                      <li><i class="fa fa-check-circle"></i> Rest Api</li>
                      <li><i class="fa fa-check-circle"></i> Html/Css</li>
                      <li><i class="fa fa-check-circle"></i> Javascript</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <!-- -->
          <!-- Project item-->
          <li class="col-md-12 isotope-item mt-xl web">
            <div class="row">
              <div class="col-md-6">
                <div class="portfolio-item">
                    <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                      <span class="thumb-info-wrapper">
                        <img src="assets/img/projects/yenimini.png" class="img-responsive" alt="">

                      </span>
                    </span>
                </div>
              </div>
              <div class="col-md-6">


                <h4 class="heading-primary">yenimini.com</h4>
                <p class="mt-xlg">İkinci el bebek ürünlerinin üyeler tarafından satışa sunulduğu c2c e-ticaret uygulaması</p>

                <div class="header-logo">

                            </div>

                <ul class="portfolio-details">
                  <li>
                    <p><strong>Kullanılan Teknolojiler</strong></p>

                    <ul class="list list-inline list-icons">
                      <li><i class="fa fa-check-circle"></i> Asp.Net</li>
                      <li><i class="fa fa-check-circle"></i> Sql Server</li>
                      <li><i class="fa fa-check-circle"></i> Html/Css</li>
                      <li><i class="fa fa-check-circle"></i> Javascript</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <!-- -->
          <!-- Project item-->
          <li class="col-md-12 isotope-item mt-xl android">
            <div class="row">
              <div class="col-md-6">
                <div class="portfolio-item">
                    <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                      <span class="thumb-info-wrapper">
                        <img src="assets/img/projects/gizli.png" class="img-responsive" alt="">

                      </span>
                    </span>
                </div>
              </div>
              <div class="col-md-6">


                <h4 class="heading-primary">Ürün denetim</h4>
                <p class="mt-xlg">Pakmaya firmasının ürünlerini satan firmaları denetlediği, ürünlerinin satış fiyatı, raf değerleri vs gibi değerlemeleri yaptığı uygulamadır.</p>

                <div class="header-logo">

                            </div>

                <ul class="portfolio-details">
                  <li>
                    <p><strong>Kullanılan Teknolojiler</strong></p>

                    <ul class="list list-inline list-icons">
                      <li><i class="fa fa-check-circle"></i> Java</li>
                      <li><i class="fa fa-check-circle"></i> Firebase RealtimeDB</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <!-- -->
          <!-- Project item-->
          <li class="col-md-12 isotope-item mt-xl android">
            <div class="row">
              <div class="col-md-6">
                <div class="portfolio-item">
                    <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                      <span class="thumb-info-wrapper">
                        <img src="assets/img/projects/sondakika.png" class="img-responsive" alt="">

                      </span>
                    </span>
                </div>
              </div>
              <div class="col-md-6">


                <h4 class="heading-primary">sondakika.com</h4>
                <p class="mt-xlg">sondakika.com haber sitesinin mobil uygulamasıdır</p>

                <div class="header-logo">
                                 <a href="https://play.google.com/store/apps/details?id=app.ym.sondakika">
                                 <img alt="YKBTech" width="152" height="45" src="assets/img/projects/googleplay.png">
                                 </a>
                            </div>

                <ul class="portfolio-details">
                  <li>
                    <p><strong>Kullanılan Teknolojiler</strong></p>

                    <ul class="list list-inline list-icons">
                      <li><i class="fa fa-check-circle"></i> Java</li>
                      <li><i class="fa fa-check-circle"></i> Rest Api</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <!-- -->
          <!-- Project item-->
          <li class="col-md-12 isotope-item mt-xl android">
            <div class="row">
              <div class="col-md-6">
                <div class="portfolio-item">
                    <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                      <span class="thumb-info-wrapper">
                        <img src="assets/img/projects/gizli.png" class="img-responsive" alt="">

                      </span>
                    </span>
                </div>
              </div>
              <div class="col-md-6">


                <h4 class="heading-primary">Ürün barkod takip</h4>
                <p class="mt-xlg">Ürün barkodlarınızın uygulama üzerinden sıralı bir şekilde okunmasını ve yönetilerek merkeze gönderiminin yapılamasını sağlar</p>

                <div class="header-logo">

                            </div>

                <ul class="portfolio-details">
                  <li>
                    <p><strong>Kullanılan Teknolojiler</strong></p>

                    <ul class="list list-inline list-icons">
                      <li><i class="fa fa-check-circle"></i> Java</li>
                      <li><i class="fa fa-check-circle"></i> Rest Api</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <!-- -->
          <!-- Project item-->
          <li class="col-md-12 isotope-item mt-xl ios android">
            <div class="row">
              <div class="col-md-6">
                <div class="portfolio-item">
                    <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                      <span class="thumb-info-wrapper">
                        <img src="assets/img/projects/gizli.png" class="img-responsive" alt="">

                      </span>
                    </span>
                </div>
              </div>
              <div class="col-md-6">


                <h4 class="heading-primary">Guardware</h4>
                <p class="mt-xlg">Meyer firmasına geliştirilen uygulama devriye gezen güvenliklerin devriye noktalarına ziyareti takibi, resimli olağan dışı olay bildirimi </p>

                <div class="header-logo">

                            </div>

                <ul class="portfolio-details">
                  <li>
                    <p><strong>Kullanılan Teknolojiler</strong></p>

                    <ul class="list list-inline list-icons">
                      <li><i class="fa fa-check-circle"></i> Java</li>
                      <li><i class="fa fa-check-circle"></i> Rest Api</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <!-- -->
          <!-- Project item-->
          <li class="col-md-12 isotope-item mt-xl ios android">
            <div class="row">
              <div class="col-md-6">
                <div class="portfolio-item">
                    <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                      <span class="thumb-info-wrapper">
                        <img src="assets/img/projects/meyer_personel_takip.png" class="img-responsive" alt="">

                      </span>
                    </span>
                </div>
              </div>
              <div class="col-md-6">


                <h4 class="heading-primary">Personel takip</h4>
                <p class="mt-xlg">Meyer firmasına geliştirilen personelin izin, mola, giriş-çıkış takiplerinin yapıldığı uygulamadır</p>

                <div class="header-logo">

                            </div>

                <ul class="portfolio-details">
                  <li>
                    <p><strong>Kullanılan Teknolojiler</strong></p>

                    <ul class="list list-inline list-icons">
                      <li><i class="fa fa-check-circle"></i> Java</li>
                      <li><i class="fa fa-check-circle"></i> Swift</li>
                      <li><i class="fa fa-check-circle"></i> Rest Api</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <!-- -->
          <!-- Project item-->
          <li class="col-md-12 isotope-item mt-xl ios android">
            <div class="row">
              <div class="col-md-6">
                <div class="portfolio-item">
                    <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                      <span class="thumb-info-wrapper">
                        <img src="assets/img/projects/gizli.png" class="img-responsive" alt="">

                      </span>
                    </span>
                </div>
              </div>
              <div class="col-md-6">


                <h4 class="heading-primary">Ev Otomasyon</h4>
                <p class="mt-xlg">AlfaNet firmasının PLC ler üzerinden yönettiği otomasyon sisteminin mobil kumanda uygulamasıdır</p>

                <div class="header-logo">
                            </div>

                <ul class="portfolio-details">
                  <li>
                    <p><strong>Kullanılan Teknolojiler</strong></p>

                    <ul class="list list-inline list-icons">
                      <li><i class="fa fa-check-circle"></i> Java</li>
                      <li><i class="fa fa-check-circle"></i> Objective-C</li>
                      <li><i class="fa fa-check-circle"></i> Rest Api</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <!-- -->
          <!-- Project item-->
          <li class="col-md-12 isotope-item mt-xl iot">
            <div class="row">
              <div class="col-md-6">
                <div class="portfolio-item">
                    <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                      <span class="thumb-info-wrapper">
                        <img src="assets/img/projects/gizli.png" class="img-responsive" alt="">

                      </span>
                    </span>
                </div>
              </div>
              <div class="col-md-6">


                <h4 class="heading-primary">Akıllı Priz</h4>
                <p class="mt-xlg">Kablolu, kablosuz çalışabilen, internete bağlı komutlar alabilen ve senaryolara göre davranabilen sabit veya portatif seçenekleri bulunan priz üretimidir.</p>

                <div class="header-logo">

                            </div>

                <ul class="portfolio-details">
                  <li>

                  </li>
                </ul>
              </div>
            </div>
          </li>
          <!-- -->
          <!-- Project item-->
          <li class="col-md-12 isotope-item mt-xl iot">
            <div class="row">
              <div class="col-md-6">
                <div class="portfolio-item">
                    <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                      <span class="thumb-info-wrapper">
                        <img src="assets/img/projects/gizli.png" class="img-responsive" alt="">

                      </span>
                    </span>
                </div>
              </div>
              <div class="col-md-6">


                <h4 class="heading-primary">İntes DAQ</h4>
                <p class="mt-xlg">Ses verisinin işlenerek aynı anda birden fala kalandan kayıt ve dinleme yapılabilmesini sağlayacak cihazın üretimi</p>

                <div class="header-logo">

                            </div>

                <ul class="portfolio-details">
                  <li>

                  </li>
                </ul>
              </div>
            </div>
          </li>
          <!-- -->
          <!-- Project item-->
          <li class="col-md-12 isotope-item mt-xl web">
            <div class="row">
              <div class="col-md-6">
                <div class="portfolio-item">
                    <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                      <span class="thumb-info-wrapper">
                        <img src="assets/img/projects/gizli.png" class="img-responsive" alt="">

                      </span>
                    </span>
                </div>
              </div>
              <div class="col-md-6">


                <h4 class="heading-primary">Elektronik Adisyon ve Stok Takip</h4>
                <p class="mt-xlg">Tedarikçiden son müşteriye kadar ürünlerin alım, stok ve tüketim süreçlerinin windows 6.1 mobil el terminalleri yardımı ve web sisteminde takibinin yapılmasını sağlar.</p>

                <div class="header-logo">

                            </div>

                <ul class="portfolio-details">
                  <li>
                    <p><strong>Kullanılan Teknolojiler</strong></p>

                    <ul class="list list-inline list-icons">
                      <li><i class="fa fa-check-circle"></i> Asp.Net</li>
                      <li><i class="fa fa-check-circle"></i> C#</li>
                      <li><i class="fa fa-check-circle"></i> Xml Web Servisleri</li>
                      <li><i class="fa fa-check-circle"></i> Sql Server</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <!-- -->

          <!--<li class="col-md-12 isotope-item mt-xl ios android">
            <div class="row">
              <div class="col-md-6">
                <div class="portfolio-item">
                    <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                      <span class="thumb-info-wrapper">
                        <img src="img/projects/orbies.png" class="img-responsive" alt="">

                      </span>
                    </span>
                </div>
              </div>
              <div class="col-md-6">


                <h4 class="heading-primary">Orbies</h4>
                <p class="mt-xlg">Orbies, kişisel ve işyeri kullanımı sunan ve harita üzerinde orb oluşturmanızı sağlayan bir uygulamadır. Orb, harita üzerinde fotoğraf paylaşımıdır.</p>

                <div class="header-logo">
                                 <a href="https://itunes.apple.com/tr/app/orbies/id1245865156?mt=8">
                                 <img alt="YKBTech" width="152" height="45" src="img/projects/appstore.png">
                                 </a>

                                 <a href="https://play.google.com/store/apps/details?id=com.orb.orbiesapp">
                                 <img alt="YKBTech" width="152" height="45" src="img/projects/googleplay.png">
                                 </a>
                            </div>

                <ul class="portfolio-details">
                  <li>
                    <p><strong>Kullanılan Teknolojiler</strong></p>

                    <ul class="list list-inline list-icons">
                      <li><i class="fa fa-check-circle"></i> Swift</li>
                      <li><i class="fa fa-check-circle"></i> Android</li>
                      <li><i class="fa fa-check-circle"></i> HTML/CSS</li>
                      <li><i class="fa fa-check-circle"></i> PHP</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </li>

          <li class="col-md-12 isotope-item mt-xl ios android">
            <div class="row">
              <div class="col-md-6">
                <div class="portfolio-item">
                    <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                      <span class="thumb-info-wrapper">
                        <img src="img/projects/doviz.png" class="img-responsive" alt="">

                      </span>
                    </span>
                </div>
              </div>
              <div class="col-md-6">


                <h4 class="heading-primary">Döviz&Altın</h4>
                <p class="mt-xlg">Döviz&Altın uygulaması ile uluslararası pariteler, banka döviz kurları, serbest piyasa kurları, altın kurları ve kur grafikleri gibi bilgilere erişebilirsiniz.</p>

                <div class="header-logo">
                                 <a href="https://itunes.apple.com/tr/app/döviz-altın/id499969177?l=tr&mt=8">
                                 <img alt="YKBTech" width="152" height="45" src="img/projects/appstore.png">
                                 </a>

                                 <a href="https://play.google.com/store/apps/details?id=com.cayirtepeomer.doviz">
                                 <img alt="YKBTech" width="152" height="45" src="img/projects/googleplay.png">
                                 </a>
                            </div>

                <ul class="portfolio-details">
                  <li>
                    <p><strong>Kullanılan Teknolojiler</strong></p>

                    <ul class="list list-inline list-icons">
                      <li><i class="fa fa-check-circle"></i> Swift</li>
                      <li><i class="fa fa-check-circle"></i> Android</li>
                      <li><i class="fa fa-check-circle"></i> HTML/CSS</li>
                      <li><i class="fa fa-check-circle"></i> PHP</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </li>


          <li class="col-md-12 isotope-item mt-xl android website">
            <div class="row">
              <div class="col-md-6">
                <div class="portfolio-item">
                    <span class="thumb-info thumb-info-no-zoom thumb-info-lighten">
                      <span class="thumb-info-wrapper">
                        <img src="img/projects/ceksor.png" class="img-responsive" alt="">

                      </span>
                    </span>
                </div>
              </div>
              <div class="col-md-6">


                <h4 class="heading-primary">ÇekveSor</h4>
                <p class="mt-xlg">ÇekveSor faktoring deneyimlerini bir araya getirip KOBİ ve OBİ'lerin yaşadığı sıkıntılara çözüm sunarken, aynı anda faktoring şirketlerinin ihtiyaçlarına karşılık sağlamayı amaçlayan bir uygulamadır.</p>

                <div class="header-logo">
                                 <!--<a href="https://itunes.apple.com/tr/app/döviz-altın/id499969177?l=tr&mt=8">
                                 <img alt="YKBTech" width="152" height="45" src="img/projects/appstore.png">
                                 </a> - ->

                                 <a href="https://play.google.com/store/apps/details?id=ac.app.ceksor">
                                 <img alt="YKBTech" width="152" height="45" src="img/projects/googleplay.png">
                                 </a>
                            </div>

                <ul class="portfolio-details">
                  <li>
                    <p><strong>Kullanılan Teknolojiler</strong></p>

                    <ul class="list list-inline list-icons">
                      <li><i class="fa fa-check-circle"></i> Android</li>
                      <li><i class="fa fa-check-circle"></i> HTML/CSS</li>
                      <li><i class="fa fa-check-circle"></i> Firebase</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>

        </li> -->
        </ul>
      </div>
    </div>

  </div>

</div>
